import React from 'react';
import AgreementDetailVendor from './Vendor/AgreementDetailVendor';
import * as Constants from 'constants/Constants';

const AgreementsContainer = (props) => {
    const connectionType = props.match.params.type;
    const id = props.match.params.id;
    const activity = props.match.params.activity;

    switch (connectionType) {
        case Constants.ACCOUNT_TYPE_VENDOR.toUpperCase():
            return (
                <AgreementDetailVendor
                    connectionType={connectionType}
                    id={id}
                    activity={activity}
                ></AgreementDetailVendor>
            );
        default:
            return null;
    }
};

export default AgreementsContainer;
